import React from 'react';
import { I18n } from 'react-redux-i18n';
import { openPrivacyPolicy, openTermsAndConditions } from '../../../utils';
import './AppFooter.scss';

const AppFooter = () => (
    <footer className='app-footer'>
        <button type='button' className='app-footer__link' onClick={openTermsAndConditions}>
            {I18n.t('common.viewTermsAndConditions')}
        </button>
        <span className='app-footer__separator' aria-hidden='true'>
            |
        </span>
        <button type='button' className='app-footer__link' onClick={openPrivacyPolicy}>
            {I18n.t('common.viewPrivacyPolicy')}
        </button>
    </footer>
);

export default AppFooter;
